import moment from 'moment';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import template from 'gift-card/product-gift-card.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';
import { addDatePickers, getPicker } from '../../../core/js/uiSupport/datePicker';

function initPikaday() {
    const state = this.getState();
    const minDate = new Date();
    const nowInMilliseconds = minDate.getTime();
    const ninetyDaysInMilliseconds = 90 * 24 * 60 * 60 * 1000;
    const maxDate = new Date(nowInMilliseconds + ninetyDaysInMilliseconds);
    const dateFormat = state.core.featureConfigs.datetimeOptions.dateFormatString;

    const pikadayOverrides = {
        minDate: minDate,
        maxDate: maxDate
    };

    let calendarIcon = $(this.scopedSelector('.js-calendar-icon'));
    let calendarContainer = $(this.scopedSelector('.js-delivery-date-calendar-container'));

    if (calendarIcon && calendarIcon.length > 0 &&
        calendarContainer && calendarContainer.length > 0) {
        calendarIcon = calendarIcon[0];
        calendarContainer = calendarContainer[0];

        pikadayOverrides.trigger = calendarIcon;
        pikadayOverrides.container = calendarContainer;
    }

    addDatePickers(this, this.getState, pikadayOverrides);

    const $datePickerInput = $('.js-date-picker');

    // Set default date in deliver date input if it exists
    if ($datePickerInput.length) {
        const deliveryDate = moment().format(dateFormat);

        $datePickerInput.attr('value', deliveryDate);
    }

    // Populate the date picker on quickshop initialize if a delivery date exists
    // and we're within a quickshop modal
    const product = this.getTargetedProduct(this.getState());

    if (product && state.quickshop &&
        _.get(product, 'product.isEgiftCard') && _.get(product, 'productControls.validation.values.deliveryDate')) {
        const deliveryDate = product.productControls.validation.values.deliveryDate;

        if (typeof deliveryDate === 'string') {
            $datePickerInput.val(deliveryDate);
        } else {
            const deliveryDateObject = deliveryDate;
            const deliveryDateString = moment([deliveryDateObject.year, deliveryDateObject.month - 1, deliveryDateObject.day]).format(dateFormat);

            $datePickerInput.val(deliveryDateString);
        }
    }
}

function afterConstruction(store) {
    const product = this.getTargetedProduct(this.getState());

    if (_.get(product, 'product.isEgiftCard')) {
        initPikaday.bind(this)();
    }
}

function afterRender(store) {
    initPikaday.bind(this)();
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on('click', this.scopedSelector('.js-date-picker-outer'), (event) => {
        if ($(event.currentTarget).find('input').attr('disabled')) {
            event.preventDefault();
            event.stopImmediatePropagation();

            const picker = getPicker(this.templateLocation);

            if (picker) {
                picker.show();
            }
        }
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-product-gift-card',
        attachEvents: attachEvents,
        afterConstruction: afterConstruction,
        template: template,
        watch: 'product.productControls',
        name: 'productGiftCardComponent',
        forFamilyProduct: false,
        onStateChange: onStateChange,
        afterRender: afterRender,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    overrides.getState = store.getState;
    return generate(config, store, overrides);
}
